import {WarningItem} from './ui-components';
import Text from '@/components/react-native/text';
import View from '@/components/react-native/view';
import {ENoteTag, INoteInfo} from '@/types/airport';
import React, {useMemo} from 'react';

export const NotesSectionHeader = React.memo(
  ({title, backgroundColor}: {title: string; backgroundColor: string}) => (
    <View
      className="px-[16px] py-[16px] h-[52px] justify-center sticky top-0 z-10"
      style={{backgroundColor}}
    >
      <Text
        fontFamily="Geist"
        className="text-[#FAFAF9] text-[16px] font-[700] tracking-[-0.32px]"
      >
        {title}
      </Text>
    </View>
  )
);
NotesSectionHeader.displayName = 'NotesSectionHeader';

export const NotesSectionContent = React.memo(
  ({
    title,
    contentBackgroundColor,
    notes,
    tagFilter,
    onNotePress
  }: {
    title: string;
    contentBackgroundColor: string;
    notes: INoteInfo[];
    tagFilter: ENoteTag;
    onNotePress?: (note: INoteInfo) => void;
  }) => {
    const filteredNotes = useMemo(
      () => notes.filter((note) => note.tag === tagFilter),
      [notes, tagFilter]
    );

    return (
      <View
        className="py-[8px] w-full"
        style={{backgroundColor: contentBackgroundColor}}
      >
        {filteredNotes.map((note) => (
          <WarningItem
            key={note.id}
            note={note}
            category={note.category}
            content={note.content}
            onPress={onNotePress}
          />
        ))}
        {filteredNotes.length === 0 && (
          <View className="px-[16px] py-[16px]">
            <Text
              fontFamily="Geist"
              className="text-[#78716C] text-[16px] font-[400] tracking-[-0.32px]"
            >
              No {title.toLowerCase()} available.
            </Text>
          </View>
        )}
      </View>
    );
  }
);
NotesSectionContent.displayName = 'NotesSectionContent';

export const NotesSection = React.memo(
  ({
    title,
    backgroundColor,
    contentBackgroundColor,
    notes,
    tagFilter,
    onNotePress
  }: {
    title: string;
    backgroundColor: string;
    contentBackgroundColor: string;
    notes: INoteInfo[];
    tagFilter: ENoteTag;
    onNotePress?: (note: INoteInfo) => void;
  }) => {
    const filteredNotes = useMemo(
      () => notes.filter((note) => note.tag === tagFilter),
      [notes, tagFilter]
    );

    return (
      <View>
        <View
          className="px-[16px] py-[16px] h-[52px] justify-center sticky top-0 z-10"
          style={{backgroundColor}}
        >
          <Text
            fontFamily="Geist"
            className="text-[#FAFAF9] text-[16px] font-[700] tracking-[-0.32px]"
          >
            {title}
          </Text>
        </View>

        <View
          className="py-[8px]"
          style={{backgroundColor: contentBackgroundColor}}
        >
          {filteredNotes.map((note) => (
            <WarningItem
              key={note.id}
              note={note}
              category={note.category}
              content={note.content}
              onPress={onNotePress}
            />
          ))}
          {filteredNotes.length === 0 && (
            <View className="px-[16px] py-[16px]">
              <Text
                fontFamily="Geist"
                className="text-[#78716C] text-[16px] font-[400] tracking-[-0.32px]"
              >
                No {title.toLowerCase()} available.
              </Text>
            </View>
          )}
        </View>
      </View>
    );
  }
);
NotesSection.displayName = 'NotesSection';
